// @flow

/** @jsx h */

/* eslint-disable compat/compat */

import { h, Component } from 'preact'
import styles from './App.css'
import { connect } from '../../lib/provider'
import { bem } from '../../lib/bem'
import MaxViewportRect from './MaxViewportRect'
import { Background } from './Background'
import { createChapters } from './chapters'
import { toArray } from '../../lib/array'
import PolopolyPicture from './PolopolyPicture'
// import PolopolyPicture from './PolopolyPicture'
import { trackAction } from '../../lib/googleAnalytic'
// import type { Chapter } from './chapters'

type Props = {
  sendGaEvent: (Object) => void
}

type State = {
  visible: boolean,
  index: number,
  trackedInitial: boolean,
  viewportHeight: number | null
}

const trackingName = 'dh-sporing-2020'

class _App extends Component<Props, State> {
  /* Example of how to send a click event to google analytics
  handleClick = () => {
    this.props.sendGaEvent({
      action: 'click'
    })
  }
  */

  elm: HTMLDivElement
  background: any

  constructor () {
    super()
    this.state = {
      visible: false,
      index: -1,
      trackedInitial: false,
      viewportHeight: null
    }
    const chapters = createChapters()
    this.sectionElements = toArray(new Array(chapters.length))
    this.triggerElements = toArray(new Array(chapters.length))
  }

  componentDidMount () {
    this.insersectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.target === this.elm) {
            this.setVisiblity(entry.isIntersecting)
          } else if (entry.isIntersecting) {
            this.setIndex(this.triggerElements.indexOf(entry.target))
          }
        })
      },
      {
        rootMargin: '-10px -10px -10px -10px',
        threshold: [0]
      }
    )

    this.triggerElements.forEach(triggerElm => this.insersectionObserver.observe(triggerElm))
    this.insersectionObserver.observe(this.elm)
  }

  componentWillUnmount () {
    this.triggerElements.forEach(triggerElm => this.insersectionObserver.unobserve(triggerElm))
    this.insersectionObserver.unobserve(this.elm)
    this.insersectionObserver.disconnect()
  }

  handleViewportChange = (viewport: any) => {
    if (this.state.viewportHeight !== viewport.height) {
      this.setState({ viewportHeight: viewport.height })
    }
  }

  setIndex (index: number) {
    if (this.state.index !== index) {
      this.setState({ index })
    }
  }

  setVisiblity (visible: boolean) {
    if (!this.state.trackedInitial && visible) {
      trackAction(visible ? 'SCROLL_IN' : 'SCROLL_OUT', trackingName)
      trackAction(`LOAD_SUCCESS/index:${this.state.index}`, trackingName)
      this.setState({ visible, trackedInitial: true })
    } else if (this.state.visible !== visible) {
      trackAction(visible ? 'SCROLL_IN' : 'SCROLL_OUT', trackingName)
      this.setState({ visible })
    }
  }

  render () {
    const { visible, viewportHeight } = this.state
    const chapters = createChapters()

    const mediaContainerInlineStyle = {}
    if (viewportHeight !== null) {
      mediaContainerInlineStyle.height = `${viewportHeight}px`
    }

    const textSectionInlineStyle = {}
    if (viewportHeight !== null) {
      textSectionInlineStyle.paddingBottom = `calc(${viewportHeight}px - 20px)`
    }
    return (
      <div className={bem(styles.app, visible && 'visible')} ref={elm => (this.elm = elm)}>
        <MaxViewportRect height='100' onViewportChange={this.handleViewportChange} />
        <div className={styles.app__mediaContainer} style={mediaContainerInlineStyle}>
          <Background chapters={chapters} chapterIndex={this.state.index} ref={elm => { this.background = elm }} />
          {
            chapters.map((chapter: Chapter, idx) => {
              return (
                <div key={idx} className={styles.app__mediaFallback}>
                  <PolopolyPicture imageId={chapter.fallbackPicture} />
                </div>
              )
            })
          }
        </div>

        <div className={styles.app__itemContainer}>
          {
            chapters.map((section, idx) => {
              return (
                <section
                  key={idx}
                  className={styles.textSection}
                  style={textSectionInlineStyle}
                  ref={elm => { this.sectionElements[idx] = elm }}>
                  <div className={bem(styles.textSection__card, section.textAlign)}
                    ref={elm => { this.triggerElements[idx] = elm }}>
                    {section.title && <h2>{section.title}</h2>}
                    {section.text && <p dangerouslySetInnerHTML={{ __html: section.text }} />}
                    {section.link && section.link.url && (
                      <p>
                        <a href={section.link.url}>{section.link.text}</a>
                        &nbsp;
                        <svg style={{ width: '1.5em', height: '1em', verticalAlign: 'middle' }} aria-hidden='true'>
                          <use xlinkHref='#nrk-arrow-right' />
                        </svg>
                      </p>
                    )}
                  </div>
                </section>
              )
            })
          }
        </div>
      </div>
    )
  }
}

/*
const mapContextToProps = context => ({
  ...context,
  sendCustomGaEvent: () => context.sendEvent({ action: 'my custom event action' })
})
*/

const connector = connect()
// const connector = connect(mapContextToProps)
export const App = connector(_App)



// WEBPACK FOOTER //
// ./src/v1/components/App.js